/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Billing_NameInputs */

const en_marketing_feature_billing_name = /** @type {(inputs: Marketing_Feature_Billing_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

const es_marketing_feature_billing_name = /** @type {(inputs: Marketing_Feature_Billing_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación`)
};

const fr_marketing_feature_billing_name = /** @type {(inputs: Marketing_Feature_Billing_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturation`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Marketing_Feature_Billing_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_billing_name = /** @type {((inputs?: Marketing_Feature_Billing_NameInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Billing_NameInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_billing_name(inputs)
	if (locale === "es") return es_marketing_feature_billing_name(inputs)
	return fr_marketing_feature_billing_name(inputs)
});